<template>
  <div class="coworker-search-page">
    <h2>Coworker Search</h2>
    <hr>
    <div class="subheader-wrapper">
      <h4>Coworkers</h4>
      <!-- <div class="icon-group">
        <i class="fa fa-file" aria-hidden="true"></i>
      </div> -->
    </div>
    <hr>
    <BasicDataGrid 
      v-if="!loading"
      gridRef="coworkerSearchGrid"
      :dataSource="coworkers" 
      :dataGridKey="dataGridKey"
      :columns="columns"
      :multiSelect="false"
      noDataText="No coworkers found"
      :allowExport="false"
      :showColumnLines="true"/> 
  </div>
</template>
<script>
import BasicDataGrid    from '@/components/BasicDataGrid.vue';

import { CoworkerService }  from '@/services';

// import { getDataSource }    from "../../../modules/helpers.js";
// let coworkers = getDataSource('colleagues')

export default {
  name: 'CoworkerSearch',
  components: {
    BasicDataGrid,
  },
  data() {
    return {
      loading: false,
      coworkers: [],
      dataGridKey: 'Id',
      columns: [
        {text: 'ID', value: 'Id', dataType: "number"}, 
        {text: 'Code', value:'Code', dataType: "string"}, 
        {text: 'First Name', value:'FirstName', dataType: "string"}, 
        {text: 'Last Name', value:'LastName', dataType: "string"}, 
        {text: 'Email', value:'Email', dataType: "string"}, 
        {text: 'Phone', value:'Phone', dataType: "string"}, 
        {text: 'Title', value:'Title', dataType: "string"}, 
        {text: 'Group', value:'GroupNames', dataType: "string"},
      ],
     
    };
  },
  methods: {
    getCoworkers(){
      this.coworkers = CoworkerService.getDataSource(this.dataGridKey);
    }
  },
  created(){
    this.getCoworkers()
  }
};
</script>
<style lang="scss" scoped>
  .coworker-search-page{
    // max-width: 1800px;
  }
  .btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .btn {
      margin: 5px;
    }
  }
  .subheader-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-group{
      color: $primary;
      i{
        margin: 5px;
        cursor: pointer;
      }
    }
  }
</style>
